import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Flower2, Send } from "lucide-react";
import { NAV_LINKS } from "../data/site";
import { scrollTo } from "./Navbar";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Footer = () => {
  const [email, setEmail] = useState("");

  const subscribe = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/newsletter`, { email });
      toast.success("Iscrizione confermata. Riceverai riflessioni e strumenti pratici ogni mese.");
      setEmail("");
    } catch {
      toast.error("Iscrizione non riuscita. Riprova.");
    }
  };

  return (
    <footer className="bg-[#1C211E] text-[#F5F3ED] grain-overlay relative" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-full bg-[#F5F3ED] text-[#1C211E] flex items-center justify-center">
                <Flower2 size={17} strokeWidth={1.5} />
              </span>
              <span className="font-serif text-lg">Veronica Sciacquatori</span>
            </div>
            <p className="font-serif text-3xl sm:text-4xl leading-tight mt-8 max-w-md">
              Uno spazio sicuro per ritrovare <em className="text-[#D4A359] not-italic">equilibrio</em>.
            </p>
            <form onSubmit={subscribe} className="mt-9 flex gap-2 max-w-md" data-testid="newsletter-form">
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                     placeholder="La tua email per riflessioni e strumenti mensili" data-testid="newsletter-email-input"
                     className="flex-1 rounded-full bg-[#F5F3ED]/8 border border-[#F5F3ED]/15 px-5 py-3 text-sm placeholder:text-[#F5F3ED]/40 focus:outline-none focus:ring-2 focus:ring-[#D4A359]/40" />
              <button type="submit" data-testid="newsletter-submit-button" aria-label="Iscriviti"
                      className="rounded-full bg-[#C85A32] hover:bg-[#B04B26] p-3 transition-colors duration-300">
                <Send size={16} />
              </button>
            </form>
          </div>
          <div className="lg:col-span-3">
            <p className="font-mono text-xs tracking-[0.25em] uppercase text-[#D4A359]">Esplora</p>
            <nav className="mt-6 flex flex-col gap-3">
              {NAV_LINKS.map((l) => (
                <a key={l.href} href={l.href} onClick={(e) => { e.preventDefault(); scrollTo(l.href); }}
                   className="text-sm text-[#F5F3ED]/70 hover:text-[#F5F3ED] transition-colors w-max" data-testid={`footer-link-${l.href.slice(1)}`}>
                  {l.label}
                </a>
              ))}
            </nav>
          </div>
          <div className="lg:col-span-4">
            <p className="font-mono text-xs tracking-[0.25em] uppercase text-[#D4A359]">Studio</p>
            <div className="mt-6 space-y-2 text-sm text-[#F5F3ED]/70">
              <p>Via Ostiense 104B, 00154 Roma (Ostiense)</p>
              <p><a href="mailto:info@veronicasciacquatori.it" className="hover:text-[#F5F3ED] transition-colors">info@veronicasciacquatori.it</a></p>
              <p>Ricevo su appuntamento · in studio e online</p>
            </div>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-[#F5F3ED]/10 flex flex-col sm:flex-row justify-between gap-4 text-xs text-[#F5F3ED]/40">
          <p>© {new Date().getFullYear()} Dott.ssa Veronica Sciacquatori · Tutti i diritti riservati</p>
          <div className="flex gap-6">
            <a href="#top" onClick={(e) => { e.preventDefault(); scrollTo("#top"); }} className="hover:text-[#F5F3ED] transition-colors" data-testid="footer-privacy-link">Privacy Policy (GDPR)</a>
            <a href="#top" onClick={(e) => { e.preventDefault(); scrollTo("#top"); }} className="hover:text-[#F5F3ED] transition-colors" data-testid="footer-legal-link">Note Legali</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
